/** Errors + meta product events (spec 68 §6.6.3). */
import { z } from 'zod';
import { DEFAULT_SCHEMA_VER, id } from './_shared.js';

export const errorEvents = {
  'error.surfaced': {
    schema: z.object({
      account_id: id.optional(),
      route: z.string().min(1),
      error_class: z.string().min(1),
      error_code: z.string().optional(),
      trace_id: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'system.feature_used': {
    schema: z.object({ feature_slug: z.string().min(1), account_id: id.optional() }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
